export function TableFilter(props: any) {
    return (
        <div>
            <input className="form-control mb-2" placeholder="Search" onChange={(e) => props.update(e)} />
        </div>
    );
}
